import {NgModule} from '@angular/core';
import {APOLLO_OPTIONS} from 'apollo-angular';
import {ApolloClientOptions, ApolloLink, InMemoryCache,} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import {environment} from 'src/environments/environment';
import Swal from 'sweetalert2';
import {onError} from '@apollo/client/link/error';

export const graphqlURI = environment.GRAPHQL_URL; // <-- add the URL of the GraphQL server here

function errorMessage(title: string, message: string) {
  return Swal.fire({
    title,
    text: message,
    icon: 'error',
    allowOutsideClick: true,
    toast: true,
    position: 'bottom',
    showConfirmButton: false,
    timerProgressBar: true,
    padding: '20px',
    timer: 3000,
  });
}

const errorLink = onError(({graphQLErrors, networkError}) => {
  if (graphQLErrors) {
    graphQLErrors.map(({message, locations, path}) => {

      console.log(message + "****************DV ")
      if (message.search('Access is denied') >= 0) {
        if (environment.production) {
          errorMessage('Access Denied', "You Don't have Permission");
        } else {
          errorMessage(
            'Access Denied',
            "You Don't have Permission on path: " + path
          );
        }
      } else if (message.search('Signature has expired') >= 0) {
        console.log("LOG OUT")

        //TODO: improve handling
        // localStorage.setItem('urlToRedirect', Router?.prototype?.url);
        // StorageService?.prototype?.setItem('sessionExpired', 'true');
        // Router.prototype.navigate(['/login']);
        localStorage?.clear();
        window.location.assign('/login');
        errorMessage("Session Expired", 'Logged Out');

      } else {
        console.warn(message);
        if (!environment.production) {
          errorMessage('GraphQL error', message);
        }
      }
    });
  }
  if (networkError) {
    if (!environment.production) {
      console.error(`[Network error]: ${networkError}`);
    }
  }
});

export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
  return {
    link: ApolloLink.from([errorLink, httpLink.create({uri: graphqlURI})]),
    cache: new InMemoryCache({
      addTypename: false,
    }),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
    },
  };
}

@NgModule({
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})

export class GraphQLModule {

}
